module.exports = __webpack_public_path__ + "static/media/template-b.4e6888ed.svg";